import _isEmpty from 'lodash/isEmpty';

import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';

import { Form } from 'react-bulma-components';

import './input.scss';

const { Field, Label, Input } = Form;

const CustomInputV2 = (props) => {
    const {
        label,
        rightLabel,
        name,
        placeholder,
        value,
        onChange,
        onKeyDown,
        errors,
        highlightErrors,
        required,
        disabled,
        autoFocus,
        id,
        type,
        endAdornment,
        showEndAdornment,
        autoComplete
    } = props;

    const inputRef = useRef(null);
    const [inputType, setInputType] = useState(type);

    const hasErrors = !_isEmpty(errors);

    const revealPassword = (e) => {
        e.preventDefault();
        if (inputType === 'password') {
            setInputType('text');
        } else {
            setInputType('password');
        }
        if (inputRef?.current) {
            inputRef.current.focus();
        }
    };

    return (
        <Field className='custom-input__container'>
            {label && (
                <Label id={id || name} className='custom-input__label'>
                    <span>
                        {label}
                        {required && <span className='required-mark'>*</span>}
                    </span>
                    {rightLabel}
                </Label>
            )}
            <div className='custom-input__wrapper'>
                <Input
                    autoComplete={autoComplete}
                    autoFocus={autoFocus}
                    className={classNames('custom-input__field', {
                        'custom-input__field--error': hasErrors || highlightErrors,
                        'custom-input__field--adornment': showEndAdornment
                    })}
                    name={name}
                    value={value}
                    onChange={onChange}
                    onKeyDown={onKeyDown}
                    required={required}
                    aria-labelledby={id || name}
                    domRef={inputRef}
                    disabled={disabled}
                    placeholder={placeholder || ''}
                    type={inputType || 'text'}
                />
                {type === 'password' && (
                    <span
                        className={classNames(
                            {
                                'custom-input__password--revealed': inputType === 'text'
                            },
                            'custom-input__password'
                        )}
                        onClick={revealPassword}
                    />
                )}
                {showEndAdornment && endAdornment && <div className='custom-input__end-adornment'>{endAdornment}</div>}
            </div>
            {hasErrors && (
                <div className='custom-input__errors'>
                    {errors.map((error) => (
                        <p key={error}>{error}</p>
                    ))}
                </div>
            )}
        </Field>
    );
};

export default CustomInputV2;

CustomInputV2.propTypes = {
    label: PropTypes.node,
    rightLabel: PropTypes.node,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onKeyDown: PropTypes.func,
    errors: PropTypes.array,
    highlightErrors: PropTypes.bool,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    autoFocus: PropTypes.bool,
    id: PropTypes.string,
    type: PropTypes.string,
    endAdornment: PropTypes.node,
    showEndAdornment: PropTypes.bool,
    autoComplete: PropTypes.string
};
